// Il ritiro del RICAMBIO dentro la sezione Spedizione (Davide 05/10: «anche
// dentro l'ordine»). Stepper e tracking qui sotto parlano del pacco originale,
// gia' partito: senza questa riga la pagina diceva solo «Spedito» mentre il
// pezzo nuovo aspettava il ritiro (2001747332-A). Fuori dal giro del ricambio
// non esiste: nessuno spazio occupato sugli altri ordini.
import { ritiroDelRicambio } from "../../sostituzione";
import type { Order } from "../../types";
import { IconSwap } from "../icons";
import { FORMA_BADGE, pieno } from "../statoToni";

function giornoOra(iso: string | null | undefined): string | null {
  if (!iso) return null;
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return null;
  return d.toLocaleString("it-IT", {
    day: "2-digit",
    month: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
  });
}

export function RitiroRicambio({ order }: { order: Order }) {
  if (!ritiroDelRicambio(order)) return null;
  const inviata = order.pickupMailSent === true;
  const raw = order.raw ?? {};
  const quando = inviata
    ? giornoOra(order.pickupMailSentAt)
    : giornoOra(typeof raw.merce_pronta_il === "string" ? raw.merce_pronta_il : null);

  return (
    <div
      data-testid="ritiro-ricambio"
      className="mb-3 flex flex-wrap items-center gap-x-3 gap-y-1.5 rounded-md border border-line bg-paper px-3 py-2"
    >
      <IconSwap className="h-4 w-4 shrink-0 fill-none stroke-current stroke-[1.8] text-ink [stroke-linecap:round] [stroke-linejoin:round]" />
      <span className={FORMA_BADGE} style={pieno(inviata ? "ldv-inviata" : "pronto-ritiro")}>
        {inviata ? "LDV ricambio inviata" : "Ricambio pronto"}
      </span>
      <span className="min-w-0 flex-1 text-[13px] leading-snug text-ink">
        {inviata
          ? "Il fornitore ha l'etichetta della sostituzione per il pezzo nuovo."
          : "Pezzo nuovo da far ritirare: parte con l'etichetta della sostituzione, non con la LDV qui sotto (quella è dell'originale, già partito)."}
      </span>
      {quando && (
        <span className="shrink-0 text-[12px] font-medium tabular-nums text-ink">
          {inviata ? `inviata ${quando}` : `pronta dal ${quando}`}
        </span>
      )}
    </div>
  );
}
